// Enum mappings to match mobile (Flutter) client and backend expectations
// Keep numeric values in sync with:
// - mfg-invest-client/lib/data/model/enums/UserResidenceType.dart
// - mfg-invest-client/lib/data/model/enums/UserDocumentSubType.dart

// Residence enum (0 = RESIDENT_INDIVIDUAL, 1 = NOT_RESIDENT)
export const Residence = {
  RESIDENT_INDIVIDUAL: 0,
  NOT_RESIDENT: 1,
};

// UserDocumentSubType enum (document types)
export const UserDocumentSubType = {
  OTHER: 0,
  ID_CARD: 1,
  PASSPORT: 2,
  CARD_OF_RESIDENCE: 3,
  PALESTINIAN_CARD: 4,
  VISA: 5,
  DRIVE_LICENCE: 6,
  SELFIE: 7,
  BANK_STATEMENT: 8,
  TAX_STATEMENT: 9,
  UTILITY_BILL: 10,
  PROFILE: 11,
  CERTIFICATE_OF_RESIDENCE: 12,
  SIGNATURE: 13,
  COMPANY: 14,
  CHECK_SIGNATURE: 15,
  SIGNATURE_VIDEO: 16,
};

/**
 * TransactionType enum (matches App\Enums\TransactionType.php).
 * Use CASHIN (6) for Wallet tab, CASHIN_MT5 (19) for MT5 tab.
 */
/**
 * FinancialType for payment methods.
 * BANK, BINANCE, and WHISH match the Flutter client.
 * PHONE_NUMBER is the newer API type (App\Enums\FinancalType::PHONE_NUMBER).
 */
export const FinancialType = {
  BANK: 0,
  BINANCE: 1,
  WHISH: 2,
  PHONE_NUMBER: 3,
};

/** API RELATED_TO values (App\Enums\FinancalType). */
export const FinancialTypeName = {
  BANK: "bank",
  BINANCE: "binance",
  WHISH: "whish",
  PHONE_NUMBER: "phone_number",
};
/** RestrictionFor (currency restrictions). CASHOUT = 1. */
export const RestrictionFor = {
  CASHOUT: 1,
  CASHIN: 2,
  CASHIN_MT5: 3,
  DEPOSIT: 4,
  WITHDRAWAL: 5,
};

/**
 * FeesFor enum (matches App\Enums\FeesFor.php).
 * Used for wallet restrictions.
 */
export const FeesFor = {
  CASHIN: 0,
  CASHOUT: 1,
  INTERNAL_TRANSFER: 2,
  DEPOSIT: 3,
  WITHDRAWAL: 4,
  PAY_BY_CARD: 5,
  CREDIT_IN: 6,
  CASHIN_MT5: 7,
};

export const TransactionType = {
  ALL: -1,
  INTERNAL_TRANSFER: 1,
  ADMIN_FEES: 2,
  GENERATE: 3,
  DEPOSIT: 4,
  WITHDRAWAL: 5,
  CASHIN: 6,
  CASHOUT: 7,
  COMMISSION: 8,
  CREDIT_IN: 9,
  CREDIT_OUT: 10,
  EXCHANGE: 11,
  REFUND: 12,
  PAY_BY_CARD: 13,
  RESET_WALLET: 14,
  RESET_BALANCE_MT5: 15,
  COLLECTED: 16,
  REFUND_COLLECTED: 17,
  TRANSFER: 18,
  CASHIN_MT5: 19,
  BALANCE_REPORT: 21,
};

/**
 * AccountType enum (matches backend account type values).
 * Used for trading account type identification.
 */
export const AccountType = {
  REAL: 0,
  BROKER: 1,
  DEMO: 2,
  ADMIN: 3,
  ADMIN_WALLET: 4,
  WALLET: 5,
};

/**
 * TransactionStatus enum (matches mfg-invest-client/lib/data/model/enums/TransactionStatus.dart).
 */
export const TransactionStatus = {
  STARTED: 0,
  PENDING: 1,
  FAILED: 2,
  COMPLETED: 3,
  REJECTED: 4,
  CANCELED: 5,
  PROGRESSING: 6,
  PENDING_USER: 7,
  COLLECTED: 8,
  TRANSFERRED: 9,
};


